import React, { useRef, useState } from "react";
import RichText from "@/components/RichText/RichText";
import styles from "./ReadMore.module.css";
import { ArrowRight } from "lucide-react";

interface ReadMoreDropDownProps {
  Data: {
    title: string;
    description: any;
  };
}

const ReadMoreDropDown: React.FC<ReadMoreDropDownProps> = ({ Data }) => {
  const [isOpen, setIsOpen] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  const toggleReadMore = () => {
    setIsOpen(!isOpen);
  };

  const closeDropdown = () => {
    setIsOpen(false);
    const element = document.getElementById("read-more-section");
    if (element) {
      const yOffset = -120;
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <div className={styles.Readmore} id="read-more-section" ref={sectionRef}>
      <div className={styles.ReadmoreSection}>
        <div className={styles.headingRow}>
          <h2 className={styles.banner}>{Data.title}</h2>
          {!isOpen && (
            <button onClick={toggleReadMore} className={styles.readmoreButton}>
              {"Read More"}
              <ArrowRight />
            </button>
          )}
        </div>

        <div
          className={`${styles.paragraph} ${
            isOpen ? styles.show : styles.hide
          }`}
        >
          <RichText data={Data.description} />
          <div className={styles.closeButtonContainer}>
            {isOpen && (
              <button onClick={closeDropdown} className={styles.closeButton}>
                Close
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReadMoreDropDown;
